import { createSlice } from "@reduxjs/toolkit";
import { updateTermsAndConditionsAPI } from "../../services/updateTermsAndConditions";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const updateTermsAndConditionsSlice = createSlice({
  name: "updateTermsAndConditions",
  initialState,
  reducers: {
    updateTermsAndConditionsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    updateTermsAndConditionsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "Saved successfully";
      state.statusCode = undefined;
    },
    updateTermsAndConditionsInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    updateTermsAndConditionsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const updateTermsAndConditionsHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(updateTermsAndConditionsAction.updateTermsAndConditionsInfo());
      const response = await updateTermsAndConditionsAPI(payload, requestOptions);
      dispatch(
        updateTermsAndConditionsAction.updateTermsAndConditionsInfoSuccess(
          response,
        ),
      );
      return response;
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        updateTermsAndConditionsAction.updateTermsAndConditionsInfoFailure(
          failurePayload,
        ),
      );
    }
  };

export default updateTermsAndConditionsSlice.reducer;
export const updateTermsAndConditionsAction =
  updateTermsAndConditionsSlice.actions;
